import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { NovitaetenLookupService, StatistikService } from 'FoxxyLib';
import { Observable, Subject, fromEvent, of } from 'rxjs';
import { debounceTime, startWith, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-novitaetendiagramm-soma',
    templateUrl: './novitaetendiagramm-soma.component.html',
    styleUrls: ['./novitaetendiagramm-soma.component.scss'],
    standalone: false,
    providers: [StatistikService, NovitaetenLookupService]
})
export class NovitaetendiagrammSomaComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('ContainerRef') private containerRef?: ElementRef<HTMLDivElement>;

  selectTitel$: Observable<string> = of (null) ;
  selectSOMADiagramm$ : Observable<any[]> = of([]);
  chartView: [number, number] = [300, 300];

  private readonly destroy$ = new Subject<void>();

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = true;
  showLegend: boolean = false;
  showXAxisLabel: boolean = false;
  xAxisLabel: string = 'Novitäten Statistik';
  showYAxisLabel: boolean = true;
  yAxisLabel: string = '';
  animations: boolean = true;

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#aae3f5']
  };





  onSelect(event) {
    console.log(event);
  }

  constructor(
    private statistikService : StatistikService,
    private cdr: ChangeDetectorRef
  )
  {

    this.selectSOMADiagramm$ = this.statistikService.selectSOMADiagramm$;
    this.selectTitel$ = this.statistikService.selectTitel$;

  }




  ngOnInit(): void {



  }

  ngAfterViewInit(): void {
    fromEvent(window, 'resize')
      .pipe(startWith(null), debounceTime(50), takeUntil(this.destroy$))
      .subscribe(() => this.updateChartView());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateChartView(): void {
    const width = this.containerRef?.nativeElement.offsetWidth ?? this.chartView[0];
    if (width !== this.chartView[0]) {
      this.chartView = [width, 300];
      this.cdr.detectChanges();
    }
  }

}
